import React from 'react';
import { useNavigate } from 'react-router-dom';
import { shortenDescription } from '../../../common/description';

function UserCard({ user }) {
  const navigate = useNavigate();
  const thumbnailUrl = user.thumbnail ? `/files/thumbnail/${user.thumbnail}` : '/noimage.png';
  const handleClick = () => {
    navigate(`/mypage?id=${user.id}`);
  };

  return (
    <div style={{
      border: '1px solid #ccc',
      padding: '12px',
      borderRadius: '8px',
      width: '220px',
      cursor: 'pointer',
    }} onClick={handleClick}>
      <img src={thumbnailUrl} alt="thumb" style={{ width: '100%', height: 'auto' }} />
      <h4>{user.name}</h4>
      <p>{shortenDescription(user.description, 20)}</p>
      <p>参加チケット: {user.ticket}枚</p>
    </div>
  );
}

export default UserCard;
